import { TruthAssets } from "./TruthAssets"

export class TruthQuestion {
    friendQuestion: boolean
    question: string
    headSymbol: string
    instructions: string
    correctAnswer: number
    raiseHands: string
}

export const truthQuestions: Array<TruthQuestion> = [
    {
        friendQuestion: false,
        question: "How many of you have smoked marijuana in the last month?",
        headSymbol: TruthAssets.WEED,
        instructions: `Click on the heads of the teens to show how many you guess.\nIf you don’t ` +
            `think any kids have smoked marijuana, then click on the "0" button and then click next.`,
        correctAnswer: 2,
        raiseHands: "All right everyone, it’s time to tell the truth. Raise your hand if you’ve smoked marijuana in the last month?"
    },
    {
        friendQuestion: true,
        question: "How many of you have smoked a cigarette within the last month?",
        headSymbol: TruthAssets.CIGARETTE,
        instructions: `Click on the heads of the teens to show how many you guess or click on the "0" button.`,
        correctAnswer: 1,
        raiseHands: "All right everyone, it’s time to tell the truth. Raise your hand if you’ve smoked a cigarette in the last month."
    },
    {
        friendQuestion: false,
        question: "How many of you have gotten drunk in the past month?",
        headSymbol: TruthAssets.BEER,
        instructions: `Click on the heads of the teens to show how many you guess or click on the "0" button.`,
        correctAnswer: 2,
        raiseHands: "All right everyone, it’s time to tell the truth. Raise your hand if you’ve gotten drunk in the past month."
    },
    {
        friendQuestion: true,
        question: "How many of you have vaped in the last month?",
        headSymbol: TruthAssets.ECIG,
        instructions: `Click on the heads of the teens to show how many you guess or click on the "0" button.`,
        correctAnswer: 2,
        raiseHands: "All right, if you’ve vaped in the last month, raise your hand."
    },
    {
        friendQuestion: false,
        question: "How many of you have had a drink of alcohol in the last month?",
        headSymbol: TruthAssets.BEER,
        instructions: `Click on the heads of the teens to show how many you guess or click on the "0" button.`,
        correctAnswer: 2,
        raiseHands: "All right everyone, it’s time to tell the truth. Raise your hand if you’ve had a drink in the last month."
    },
    {
        friendQuestion: true,
        question: "In the last month how many of you have tried smokeless tobacco?",
        headSymbol: TruthAssets.CHEW_CAN,
        instructions: `Click on the heads of the teens to show how many you guess or click on the "0" button.`,
        correctAnswer: 1,
        raiseHands: "Okay you guys, raise your hand if you’ve tried smokeless tobacco in the last month."
    },
]
